import { lazy } from 'react'
import urls from './urls'

const CarrierHomeV2 = lazy(() => import('../components/pages/CarrierHomeV2/CarrierHomeV2'))
const Trip = lazy(() => import('../components/pages/Trip/Trip'))
const InvoicesContainer = lazy(() => import('../components/pages/Invoices/InvoicesContainer'))
const TripLeg = lazy(() => import('../components/pages/TripLeg/TripLeg'))
const LoadContainer = lazy(() => import('../components/pages/Load/LoadContainer'))
const TripLegPublic = lazy(() => import('../components/pages/TripLegPublic/TripLegPublic'))
const TripLegPublicSuccess = lazy(() =>
  import('../components/pages/TripLegPublicSuccess/TripLegPublicSuccess')
)
const LoadsContainer = lazy(() => import('../components/pages/Loads/Loads'))
const AuthenticationSupport = lazy(() =>
  import('../components/pages/AuthenticationSupport/AuthenticationSupport')
)
const ContactOption = lazy(() => import('../components/pages/ContactOption/ContactOption'))
const Login = lazy(() => import('../components/molecules/Authentication/Login'))
const Otp = lazy(() => import('../components/molecules/Authentication/Otp'))
const EmailPassword = lazy(() => import('../components/molecules/Authentication/EmailPassword'))
const ForgotPassword = lazy(() => import('../components/molecules/Authentication/ForgotPassword'))
const ForgotPasswordSuccess = lazy(() =>
  import('../components/molecules/Authentication/ForgotPasswordSuccess')
)
const SignUp = lazy(() => import('../components/molecules/Authentication/SignUp'))
const CountrySelection = lazy(() => import('../components/molecules/Authentication/CountrySelection'))
const Policies = lazy(() => import('../components/molecules/Authentication/Agreements'))
const CompanyTitle = lazy(() => import('../components/molecules/Authentication/CompanyTitle'))
const UserName = lazy(() => import('../components/molecules/Authentication/UserName'))
const SetPassword = lazy(() => import('../components/molecules/Authentication/SetPassword'))
const NewContactInfo = lazy(() => import('../components/molecules/Authentication/NewContactInfo'))
const AuthSuccess = lazy(() => import('../components/pages/AuthenticationSuccess/AuthenticationSuccess'))
const AuthenticationRedirectWithLoad = lazy(() =>
  import('../components/pages/AuthenticationRedirectWithLoad/AuthenticationRedirectWithLoad')
)

export type MenuValidationsType = Record<string, string[]>

export interface IRouteConfig {
  url: string
  component: any
  protectedRoute?: boolean
  enabled?: boolean
  key?: string
  scopes?: string[]
  role?: string
  validations?: MenuValidationsType
}

export const routerDefinitions: { [key: string]: IRouteConfig } = {
  Home: {
    key: 'Home',
    url: urls.Home,
    component: Login,
    protectedRoute: true,
  },
  EmailLogin: {
    key: 'EmailLogin',
    url: urls.EmailLogin,
    component: Login,
    protectedRoute: false,
  },
  PhoneNumberLogin: {
    key: 'PhoneNumberLogin',
    url: urls.PhoneNumberLogin,
    component: Login,
    protectedRoute: false,
  },
  EmailPassword: {
    key: 'EmailPassword',
    url: urls.EmailPassword,
    component: EmailPassword,
    protectedRoute: false,
  },
  ForgotPassword: {
    key: 'ForgotPassword',
    url: urls.ForgotPassword,
    component: ForgotPassword,
    protectedRoute: false,
  },
  ForgotPasswordSuccess: {
    key: 'ForgotPasswordSuccess',
    url: urls.ForgotPasswordSuccess,
    component: ForgotPasswordSuccess,
    protectedRoute: false,
  },
  PhoneNumberOtp: {
    key: 'PhoneNumberOtp',
    url: urls.PhoneNumberOtp,
    component: Otp,
    protectedRoute: false,
  },
  EmailVerification: {
    key: 'EmailVerification',
    url: urls.EmailVerification,
    component: Otp,
    protectedRoute: false,
  },
  EmailVerificationNewContact: {
    key: 'EmailVerificationNewContact',
    url: urls.EmailVerificationNewContact,
    component: Otp,
    protectedRoute: false,
  },
  Otp: {
    key: 'Otp',
    url: urls.Otp,
    component: Otp,
    protectedRoute: false,
  },
  EmailSignUp: {
    key: 'EmailSignUp',
    url: urls.EmailSignUp,
    component: SignUp,
    protectedRoute: false,
  },
  PhoneNumberSignUp: {
    key: 'PhoneNumberSignUp',
    url: urls.PhoneNumberSignUp,
    component: SignUp,
    protectedRoute: false,
  },
  SetPassword: {
    key: 'SetPassword',
    url: urls.SetPassword,
    component: SetPassword,
    protectedRoute: false,
  },
  SetPasswordNewContact: {
    key: 'SetPasswordNewContact',
    url: urls.SetPasswordNewContact,
    component: SetPassword,
    protectedRoute: false,
  },
  ConfirmForgotPassword: {
    key: 'ConfirmForgotPassword',
    url: urls.ConfirmForgotPassword,
    component: SetPassword,
    protectedRoute: false,
  },
  CountrySelection: {
    key: 'CountrySelection',
    url: urls.CountrySelection,
    component: CountrySelection,
    protectedRoute: false,
  },
  Policies: {
    key: 'Policies',
    url: urls.Policies,
    component: Policies,
    protectedRoute: false,
  },
  CompanyTitle: {
    key: 'CompanyTitle',
    url: urls.CompanyTitle,
    component: CompanyTitle,
    protectedRoute: false,
  },
  UserName: {
    key: 'UserName',
    url: urls.UserName,
    component: UserName,
    protectedRoute: false,
  },
  EmailNewContact: {
    key: 'EmailNewContact',
    url: urls.EmailNewContact,
    component: NewContactInfo,
    protectedRoute: false,
  },
  PhoneNumberNewContact: {
    key: 'EmailNewContact',
    url: urls.PhoneNumberNewContact,
    component: NewContactInfo,
    protectedRoute: false,
  },
  PhoneNumberSupportSignUp: {
    key: 'PhoneNumberSupportSignUp',
    url: urls.PhoneNumberSupportSignUp,
    component: AuthenticationSupport,
    protectedRoute: false,
  },
  EmailSupportSignUp: {
    key: 'EmailSupportSignUp',
    url: urls.EmailSupportSignUp,
    component: AuthenticationSupport,
    protectedRoute: false,
  },
  PhoneNumberSupportAuth: {
    key: 'PhoneNumberSupportAuth',
    url: urls.PhoneNumberSupportAuth,
    component: AuthenticationSupport,
    protectedRoute: false,
  },
  EmailSupportAuth: {
    key: 'EmailSupportAuth',
    url: urls.EmailSupportAuth,
    component: AuthenticationSupport,
    protectedRoute: false,
  },
  AuthSuccess: {
    key: 'AuthSuccess',
    url: urls.AuthSuccess,
    component: AuthSuccess,
    protectedRoute: false,
  },
  TripLegPublic: {
    key: 'TripLegPublic',
    url: urls.TripLegPublic,
    component: TripLegPublic,
    protectedRoute: false,
  },
  TripLegPublicSuccess: {
    key: 'TripLegPublicSuccess',
    url: urls.TripLegPublicSuccess,
    component: TripLegPublicSuccess,
    protectedRoute: false,
  },
  TripV2: {
    key: 'TripV2',
    url: urls.TripV2,
    component: Trip,
    protectedRoute: true,
  },
  CarrierHome: {
    key: 'CarrierHome',
    url: urls.CarrierHome,
    component: CarrierHomeV2,
    protectedRoute: true,
  },
  TripLeg: {
    key: 'TripLeg',
    url: urls.TripLeg,
    component: TripLeg,
    protectedRoute: true,
  },
  Invoices: {
    key: 'Invoices',
    url: urls.Invoices,
    component: InvoicesContainer,
    protectedRoute: true,
  },
  Load: {
    key: 'Load',
    url: urls.Load,
    component: LoadContainer,
    protectedRoute: true,
  },
  Loads: {
    key: 'Loads',
    url: urls.Loads,
    component: LoadsContainer,
    protectedRoute: true,
  },
  ContactOption: {
    key: 'ContactOption',
    url: urls.ContactOption,
    component: ContactOption,
    protectedRoute: false,
  },
  AuthenticationRedirectWithLoad: {
    key: 'AuthenticationRedirectWithLoad',
    url: urls.AuthRedirectionWithLoad,
    component: AuthenticationRedirectWithLoad,
    protectedRoute: false,
  },
}

// TODO: should create simple structure
const routes: IRouteConfig[] = Object.keys(routerDefinitions).map(k => {
  const route: IRouteConfig = routerDefinitions[k]
  route.enabled = route.enabled !== undefined ? route.enabled : true
  route.protectedRoute = route.protectedRoute !== undefined ? route.protectedRoute : true
  route.key = route.key ? route.key : route.url.replace('/', '')
  route.scopes = route.scopes ? route.scopes : []
  route.role = route.role ? route.role : ''
  return route
})

export { routes }
